/* eslint-disable eqeqeq */
import type { PutSubscriptionRequestBody } from '@gonfalon/openapi/operations/putSubscription';

import { BillingIntervals, BillingProcess, LimitNames, PlanTypes } from '../types';

// This typeguard is used to bridge the gap between legacy ImmutableJS billing objects and the new OpenAPI types
export function isPutSubscriptionRequestBody(obj: unknown): obj is PutSubscriptionRequestBody {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  // Only planType and billingInterval are required
  const requiredKeys = ['planType', 'billingInterval'];
  const hasAllKeys = requiredKeys.every((key) => key in obj);

  if (!hasAllKeys) {
    return false;
  }

  const typedObj = obj as { [key: string]: unknown };

  const planTypeValues = Object.values(PlanTypes as { [key: string]: PlanTypes });
  if (typedObj.planType !== null && !planTypeValues.includes(typedObj.planType as PlanTypes)) {
    return false;
  }

  const billingIntervalValues = Object.values(BillingIntervals as { [key: string]: BillingIntervals });
  if (
    typedObj.billingInterval !== null &&
    !billingIntervalValues.includes(typedObj.billingInterval as BillingIntervals)
  ) {
    return false;
  }

  if ('billingProcess' in typedObj && typedObj.billingProcess != null) {
    const billingProcessValues = Object.values(BillingProcess as { [key: string]: BillingProcess });
    if (!billingProcessValues.includes(typedObj.billingProcess as BillingProcess)) {
      return false;
    }
  }

  if ('limits' in typedObj && typedObj.limits != null) {
    if (typeof typedObj.limits !== 'object') {
      return false;
    }
    const limits = typedObj.limits as { [key: string]: number | null | undefined };
    const limitNameValues = Object.values(LimitNames as { [key: string]: LimitNames });
    if (!Object.keys(limits).every((key) => limitNameValues.includes(key as LimitNames))) {
      return false;
    }
    if (!Object.values(limits).every((value) => typeof value === 'number' || value === null)) {
      return false;
    }
  }

  if ('metadata' in typedObj && typedObj.metadata != null) {
    if (typeof typedObj.metadata !== 'object') {
      return false;
    }
  }

  if ('prorationTime' in typedObj && typedObj.prorationTime != null) {
    if (typeof typedObj.prorationTime !== 'number') {
      return false;
    }
  }

  if ('stripeToken' in typedObj && typedObj.stripeToken != null) {
    if (typeof typedObj.stripeToken !== 'string') {
      return false;
    }
  }

  return true;
}
